/* eslint-disable react-hooks/exhaustive-deps */
import { Stack, Typography } from '@mui/material'
import '../CustomFiltersStyle.scss';
import { useEffect, useRef, useState } from 'react';


const CustomBytesFilter = (props) => {
    const { 
        value = {},
        title = "",
        inputRef = null,
        localStorageKey = null,
        dataTestIdKey = null,
        onChange = () => {},
        onClick = () => {},
        onKeyDown = () => {},
        setLocalInputValue = () => {},
        item = {},
        updateFilter = () => {}
     } = props;
    const filterTestIdKey = dataTestIdKey || localStorageKey;
    const [conditionValue, setConditionValue] = useState(value?.condition || 'ls');
    const [sizeValue, setSizeValue] = useState(value?.size || 'kb');
    const [inputValue, setInputValue] = useState(value?.value || '');
     const containerRef = useRef(null);

    const onBlurHandler = () => {
        if(inputValue === '' || inputValue.trim() === '')return;
        let numericValue = parseFloat(inputValue);
        if(isNaN(numericValue))return;
        setInputValue(inputValue);
        onChange({
            value: inputValue,
            size: sizeValue,
            condition: conditionValue
        });
    }
    useEffect(() => {
        if(inputValue){
            onChange({
                value: inputValue,
                size: sizeValue,
                condition: conditionValue
            });
        }
    }, [conditionValue, sizeValue]);

    // if user press enter key and input is not empty, update the filter
    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            if(inputValue === '')return;
            let numericValue = parseFloat(inputValue);
            if(isNaN(numericValue))return;
            setInputValue(inputValue);
            onChange({
                value: inputValue,
                size: sizeValue,
                condition: conditionValue
            });
        }
    };

    // if user click outside and input is empty, reset the filter
    const handleClickOutside = (event) => {
        if (containerRef.current && !containerRef.current.contains(event.target)) {
            if(inputValue === ''){
                 updateFilter(item.id, (item) => {
                    item.isActive = false;
                    item.value = value;
                    return item;
                });
            }
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [inputValue]);


  return (
    <Stack
        direction='row'
        bgcolor={'#2E3452'}
        borderRadius={'999px'}
        justifyContent={'center'}
        alignItems={'center'}
        padding={'0px'}
        gap={'6px'}
        maxWidth={'fit-content'}
        ref={containerRef}
    >
        <Typography 
            color={'#fff'} 
            fontSize={'16px'} 
            fontWeight={500} 
            fontFamily={'Montserrat'}
            data-testid={`active-${filterTestIdKey}-filter`}
        >
                {title}
        </Typography>
        <select 
            className='bytes-conditions-select' 
            onChange={(e) => setConditionValue(e.target.value)} 
            value={conditionValue}
            data-testid={`active-${filterTestIdKey}-filter-condition-select`}
        >
            <option value="ls">{"<="}</option>
            <option value="eq">{"="}</option>
            <option value="gt">{">="}</option>
        </select>
        <input 
            className='bytes-input' 
            onChange={(e) => {
                setInputValue(e.target.value);
                setLocalInputValue(e.target.value);
            }} 
            onBlur={(e)=>{
                e.stopPropagation();
                e.preventDefault();
                const value = e.target.value;
                if (!value || value.trim() === "") return;
                onBlurHandler(e);
            }}
            value={inputValue}
            data-testid={`active-${filterTestIdKey}-filter-input`}
            ref={inputRef}
            onClick={onClick}
            onKeyDown={handleKeyDown}
        />
        <select 
            className='bytes-size-select' 
            onChange={(e) => setSizeValue(e.target.value)} 
            value={sizeValue}
            data-testid={`active-${filterTestIdKey}-filter-size-select`}
        >
            <option value="b">B</option>
            <option value="kb">KB</option>
            <option value="mb">MB</option>
            <option value="gb">GB</option>
            <option value="tb">TB</option>
        </select>
    </Stack>
  )
}

export default CustomBytesFilter